import React from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion, TableContainer } from '../../../ui/components';
import OperationCenterErrorCard, {
  ErrorType,
} from '../../../ui/components/OperationCenterErrorCard/OperationCenterErrorCard';
import { ControlIconType, FontSize } from '../../../ui/components/Accordion/Accordion';
import { getAuditHistoryLog, getEmailHistoryLog } from './auditLogConfig';
export interface AuditLogEntry {
  createdDate: string;
  createdBy: string;
  action: string;
  recId: number;
}

interface Props {
  auditHistoryLog: AuditLogEntry[];
  displayAuditEmpty: boolean;
  source?: string;
}

const AuditHistoryAccordion: React.FC<Props> = ({ auditHistoryLog, displayAuditEmpty, source }) => {
  const { t } = useTranslation();

  const sortedAuditHistoryLog = [...auditHistoryLog].sort(
    (a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime(),
  );
  return (
    <Accordion
      id="historyAccordion"
      key={sortedAuditHistoryLog?.[0]?.recId}
      iconType={ControlIconType.CHEVRON}
      title={
        source === 'dashboard' ? t('dashboard.my-team.label.emailInvitationHistory') : t('admin.auditLog.historyLog')
      }
      isBorderDesign={source !== 'dashboard'}
      fontSize={FontSize.MEDIUM}
      isOpen={true}
    >
      <div>
        {displayAuditEmpty ? (
          <OperationCenterErrorCard errorType={ErrorType.NO_RECORD} />
        ) : source === 'dashboard' ? (
          <TableContainer
            dataSource={sortedAuditHistoryLog}
            getColumns={getEmailHistoryLog}
            pagination={true}
            rowKey=""
            source={'dashboard'}
          />
        ) : (
          <TableContainer dataSource={sortedAuditHistoryLog} getColumns={getAuditHistoryLog} isAdmin />
        )}
      </div>
    </Accordion>
  );
};

export default AuditHistoryAccordion;
